// extracted by mini-css-extract-plugin
module.exports = {"inputsGroup":"InputsGroup_inputsGroup__3ZWUn","iconMod":"InputsGroup_iconMod__3h840","titleFild":"InputsGroup_titleFild__3YSJi","descrFild":"InputsGroup_descrFild__3_ufy"};